exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_menuIcon__gk7RU{font-size:1.375rem;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__gk7RU:visited{color:#333}.style_menuIcon__gk7RU:hover{opacity:.5}.style_container__2DcBs{display:flex;flex-direction:row}.style_container__2DcBs>:nth-child(2){margin-left:1rem}.style_buttons__36Ekq{padding-top:1rem}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__gk7RU",
	"container": "style_container__2DcBs",
	"buttons": "style_buttons__36Ekq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/BoundField/style.less
// module id = 1588
// module chunks = 8